import { render, staticRenderFns } from "./ClinicSetupBankDetail.vue?vue&type=template&id=a5c6a0ee&"
import script from "./ClinicSetupBankDetail.vue?vue&type=script&lang=js&"
export * from "./ClinicSetupBankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports